import {Breakpoint} from '@mui/material';
import MuiGrid, {GridProps as MuiGridProps, GridSize, GridTypeMap} from '@mui/material/Grid';
import React from 'react';

// get breakpoints and set Grid keys
type GridKeyOverwrites = {
    [P in Breakpoint]: boolean | GridSize;
};

// correctly setup grid props.
export type GridProps = MuiGridProps<GridTypeMap['defaultComponent'], Partial<GridKeyOverwrites>>;

export const Grid = React.forwardRef<HTMLDivElement, GridProps>(({
    children, ...props
}, ref) => {
    return (
        <MuiGrid
            {...props}
            ref={ref}
        >
            {children}
        </MuiGrid>
    );
});

Grid.displayName = 'Grid';
